import { render } from "./PriceSelect.vue?vue&type=template&id=68fdd746&scoped=true"
import script from "./PriceSelect.vue?vue&type=script&lang=js"
export * from "./PriceSelect.vue?vue&type=script&lang=js"

import "./PriceSelect.vue?vue&type=style&index=0&id=68fdd746&scoped=true&lang=css"

import exportComponent from "/home/pewholesaleinnovelapp/wholesale.fresherproduce.ca/releases/81914199/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68fdd746"]])

export default __exports__